import { createStore } from "vuex";
import configStore from "./modules/config";
import spinnerStore from "./modules/spinner";
import vendorStore from "./modules/vendor";
import venueStore from "./modules/venue";
import dayParts from "./modules/day-parts";
import cartStore from "./modules/cart";
import userStore from "./modules/user";
import themeStore from "./modules/theme";
import venueSettings from "./modules/venue-settings";
import levelStore from "./modules/level";
// eslint-disable-next-line no-restricted-imports
import commonStore from "./modules/common";
import deliveryStore from "./modules/delivery";
import messagesStore from "./modules/messages";
import orderAheadStore from "./modules/orderAhead";
import paymentsStore from "./modules/payments";
import modalsStore from "./modules/modals";
import featureFlagsStore from "./modules/feature-flags";
import { addStoragePlugin } from "../adapters/storageAdapter";
import { USER_ACTIONS_FILTERED_MODULES, USER_ACTIONS_FILTERED_MUTATIONS } from "@/utils";

const mutationsMiddleware = store => {
  store.subscribe(mutation => {
    // filter timeStamps module to prevent infinite loop and unwanted updated to user selection timestamp
    const module = mutation.type.split("/")[0];

    const filteredModule = USER_ACTIONS_FILTERED_MODULES.includes(module);
    const filteredMutation = USER_ACTIONS_FILTERED_MUTATIONS.includes(mutation.type);

    // Filter non user mutations happening during initialization
    if (!filteredModule && !filteredMutation) {
      store.commit("common/updateUserSelectionsStorage");
    }
  });
};

const store = createStore({
  modules: {
    config: configStore,
    spinner: spinnerStore,
    vendor: vendorStore,
    venue: venueStore,
    dayParts: dayParts,
    cart: cartStore,
    user: userStore,
    theme: themeStore,
    venueSettings: venueSettings,
    level: levelStore,
    common: commonStore,
    delivery: deliveryStore,
    messages: messagesStore,
    orderAhead: orderAheadStore,
    payments: paymentsStore,
    modals: modalsStore,
    featureFlags: featureFlagsStore
  },
  plugins: [mutationsMiddleware, addStoragePlugin]
});

export default store;
